import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ErrorBoundary from "@/components/ErrorBoundary";
import HomePage from "@/pages/HomePage";
import MissionPage from "@/pages/MissionPage";
import ChiSiamoPage from "@/pages/ChiSiamoPage";
import ServiziPage from "@/pages/ServiziPage";
import GalleriaPage from "@/pages/GalleriaPage";
import ContattiPage from "@/pages/ContattiPage";
import AdminPage from "@/pages/AdminPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true, force: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function SmoothScroll({ children }) {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  return children;
}

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <div className="relative flex min-h-screen flex-col bg-brand-slate text-slate-100">
      {!isAdmin && <div className="grain" aria-hidden="true" />}
      {!isAdmin && <Navbar />}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/mission" element={<MissionPage />} />
          <Route path="/chi-siamo" element={<ChiSiamoPage />} />
          <Route path="/attivita-e-servizi" element={<ServiziPage />} />
          <Route path="/galleria" element={<GalleriaPage />} />
          <Route path="/contatti" element={<ContattiPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
    </div>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <SmoothScroll>
          <ScrollToTop />
          <Shell />
        </SmoothScroll>
      </BrowserRouter>
      <Toaster position="bottom-right" theme="dark" />
    </ErrorBoundary>
  );
}

export default App;
